import React from 'react'
import { Menu, Dropdown, Button } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AuthAPI } from 'services/login'
import store from 'store'
import { Common } from 'services/common'
import Scopes from 'services/scope'

const mapStateToProps = ({ menu, settings, user }) => ({
  menuData: menu.menuData,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
  role: user.role,
  selectedCluster: user.selectedCluster,
  selectedScope: user.selectedScope,
  selectedPage: store.get('app.menu.selectedKeys'),
  AllAccessData: user.AllAccessData,
})

const dispatchToProps = dispatch => {
  return {
    updateScopeData: newData => {
      dispatch({ type: 'user/SET_SCOPEDETAILS', payload: newData })
    },
    updateSelection: (data, allData) => {
      dispatch({
        type: 'user/SET_STATE',
        payload: {
          selectedCluster: data.cluster,
          selectedScope: data.scope,
          AllAccessData: allData,
          eulaStatus: allData.data.EULA,
        },
      })
    },
    updateUserRole: str => {
      dispatch({
        type: 'user/SET_STATE',
        payload: {
          role: str,
        },
      })
    },
    updateAcc: data =>
      dispatch({
        type: 'user/SET_ACCDETAILS',
        payload: { selectedCluster: data.cluster, selectedScope: data.scope },
      }),
  }
}

@withRouter
@connect(mapStateToProps, dispatchToProps)
class ClusterScopetab extends React.Component {
  state = {
    // selectedCluster: Common.getSelectedCluster(),
    SelectedScope: {},
    SSID: localStorage.getItem('SSID'),
    clusterName: {},
    // ClusterData: Common.getClusterData(),
    // scopeList: Common.getScopeList(),
    // enabledScopelist: Common.getEnabledScopes(),
    accessData: {},
  }

  getClusterDetails = () => {
    var data = { ssid: this.state.SSID }
    Scopes.getUserAccessDetails(data, this.state.SSID)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry('access')
        }
        if (response.data.status === 'success') {
          var acc = response.data
          var accArr = []
          for (var i = 0; i < acc.data.access.length; i++) {
            if (acc.data.isAdmin === true && acc.data.access[i].scope_access.length > 0) {
              accArr.push(acc.data.access[i])
            } else if (acc.data.isAdmin === true && acc.data.access[i].scope_access.length === 0) {
              accArr.push(acc.data.access[i])
            } else if (acc.data.isAdmin === false && acc.data.access[i].scope_access.length === 0) {
            } else if (acc.data.isAdmin === false && acc.data.access[i].scope_access.length > 0) {
              accArr.push(acc.data.access[i])
            }
          }
          acc.data.access = accArr
          this.setState({ accessData: acc })
          var responseData = response.data
          var urlData = this.props.location.pathname.split('/')
          var selectCls = {}
          var selectScop = {}
          for (var i = 0; i < responseData.data.access.length; i++) {
            if (responseData.data.access[i].clusterId === urlData[1]) {
              selectCls = responseData.data.access[i]
              for (var j = 0; j < responseData.data.access[i].scope_access.length; j++) {
                if (
                  responseData.data.access[i].scope_access[j].scope_id === urlData[2] &&
                  responseData.data.access[i].scope_access[j].role !== 'No Access'
                ) {
                  selectScop = responseData.data.access[i].scope_access[j]
                }
              }
            }
          }
          this.setState({ clusterName: selectCls })
          this.setState({ SelectedScope: selectScop })
          var dat = { cluster: selectCls, scope: selectScop }
          this.props.updateSelection(dat, acc)
          var accessStr = ''
          var userPay = Common.decryptData(localStorage.getItem('userPayload'))
          if (acc.data.isAdmin && selectCls.access_type !== 'No Access') {
            if (Object.keys(selectScop).length > 0) {
              if (selectCls.access_type === 'Administrator') {
                accessStr = 'Admin - SecAdmin Security Engineer'
              } else {
                accessStr = 'Admin - ' + selectScop.role
              }
            } else {
              accessStr = 'Admin - No Access'
            }
          } else if (!acc.data.isAdmin && selectCls.access_type !== 'No Access') {
            if (Object.keys(selectScop).length > 0) {
              if (selectCls.access_type === 'Administrator') {
                accessStr = 'User - SecAdmin Security Engineer'
              } else {
                accessStr = 'User - ' + selectScop.role
              }
            } else {
              accessStr = 'User - No Access'
            }
          }
          if (accessStr !== '') {
            userPay.role = accessStr
            // localStorage.setItem('userPayload', Common.encryptData(userPay))
            this.props.updateUserRole(accessStr)
          }
          // window.location.reload(false)

          this.props.updateAcc(dat)
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.showNotifications('error', <div>You have no rights to access this page.</div>)
            Common.sessionExpiry()
          }
          Common.showNotifications('error', 'Connections failed')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'invalid' ||
            (error.response.data.status === 'error' &&
              error.response.data.message.indexOf('Invalid') > -1)
          ) {
            Common.sessionExpiry('access')
          }
        }
      })
  }

  componentDidMount() {
    this.getClusterDetails()
  }

  clusterIp = () => {
    AuthAPI.clusters(this.state.SSID)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry()
        }
        if (response.data.status === 'success') {
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.showNotifications('error', <div>You have no rights to access this page.</div>)
            Common.sessionExpiry()
          }
          Common.showNotifications('error', 'Connections failed')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'error' &&
            error.response.data.message.indexOf('Invalid') > -1
          ) {
            Common.sessionExpiry()
          }
        }
      })
  }

  setScope = scope => {
    var route = ''
    var cluster = this.state.clusterName
    const { location, history } = this.props
    this.setState({ SelectedScope: scope })
    this.props.updateScopeData(scope)
    var userPayload = Common.decryptData(localStorage.getItem('userPayload'))
    var dat = { cluster: cluster, scope: scope }

    userPayload.licenseType = cluster.licenseType
    if (userPayload.role.includes('Admin')) {
      userPayload.role = 'Admin - ' + scope.role
    } else if (userPayload.role.includes('User')) {
      userPayload.role = 'User - ' + scope.role
    }
    userPayload.clusterId = cluster.clusterId
    userPayload.scope_id = scope.scope_id
    userPayload.selectedScope = scope
    localStorage.setItem('userPayload', Common.encryptData(userPayload))
    let UserAcc = Common.decryptData(localStorage.getItem('UserAcc'), true)

    var accessStr = ''
    if (this.props.AllAccessData.data.isAdmin && cluster.access_type !== 'No Access') {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === 'Administrator') {
          accessStr = 'Admin - SecAdmin ' + scope.role
        } else {
          accessStr = 'Admin - ' + scope.role
        }
      } else {
        accessStr = 'Admin - No Access'
      }
    } else if (!this.props.AllAccessData.data.isAdmin && cluster.access_type !== 'No Access') {
      if (Object.keys(scope).length > 0) {
        if (cluster.access_type === 'Administrator') {
          accessStr = 'User - SecAdmin ' + scope.role
        } else {
          accessStr = 'User - ' + scope.role
        }
      } else {
        accessStr = 'User - No Access'
      }
    }
    if (accessStr !== '') {
      this.props.updateUserRole(accessStr)
    }
    // window.location.reload(false)
    if (UserAcc !== userPayload.role) {
      localStorage.setItem('UserAcc', Common.encryptData(userPayload.role, true))
    }

    this.props.updateAcc(dat)
    if (userPayload.role === 'User - Viewer' || userPayload.role === 'Admin - Viewer') {
      localStorage.setItem('UserAcc', Common.encryptData(userPayload.role, true))
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/dashboard'
      history.push(route)
    } else if (location.pathname.indexOf('/system/') > -1 && !userPayload.role.includes('Security Engineer')) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/home/' + scope.scope_id + '/' + cluster.clusterId
      history.push(route)
    } else if (location.pathname.indexOf('/clusters/') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/admin/clusters'
      history.push(route)
    } else if (location.pathname.indexOf('/components/') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/admin/components'
      history.push(route)
    } else if (location.pathname.indexOf('/user/') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/admin/user/list'
      history.push(route)
    } else if (location.pathname.indexOf('/organizations/') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/admin/organizations/list'
      history.push(route)
    } else if (location.pathname.indexOf('/dashboard') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/dashboard'
      history.push(route)
    } else if (location.pathname.indexOf('/mitre_attack') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/mitre_attack'
      history.push(route)
    } else if (location.pathname.indexOf('/uba') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/home/' + scope.scope_id + '/' + cluster.clusterId
      history.push(route)
    } else if (location.pathname.indexOf('/system/models') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/system/models'
      history.push(route)
    } else if (location.pathname.indexOf('/cases') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/incident/cases'
      history.push(route)
    } else if (location.pathname.indexOf('/extraction') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/system/extraction'
      history.push(route)
    } else if (location.pathname.indexOf('/stream') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/home/' + scope.scope_id + '/' + cluster.clusterId
      history.push(route)
    } else if (location.pathname.indexOf('/enrichment') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/system/enrichment'
      history.push(route)
    } else if (location.pathname.indexOf('/workbook') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/workbook/new'
      history.push(route)
    } else if (location.pathname.indexOf('/home') > -1) {
      route = '/' + cluster.clusterId + '/' + scope.scope_id + '/home/' + scope.scope_id + '/' + cluster.clusterId
      history.push(route)
    } else {
      let arr = location.pathname.replace('/', '').split('/')
      let finalroute = '/'
      // console.log(arr)
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          finalroute = finalroute + cluster.clusterId
        } else if (i === 1) {
          finalroute = finalroute + scope.scope_id
        } else {
          finalroute = finalroute + arr[i]
        }
        if (i + 1 !== arr.length) {
          finalroute = finalroute + '/'
        }
      }
      route = finalroute
      // console.log(route)
      history.push(route)
    }

    window.location.reload(false)
  }

  getRouteUrl = (cluster, scope, location) => {
    var scopeID = Object.keys(scope).length > 0 ? '/' + scope.scope_id : ''
    var route = ''
    if (location.pathname.indexOf('/system/') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/home' + scopeID + '/' + cluster.clusterId
      }
    } else if (location.pathname.indexOf('/clusters') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/admin/clusters'
      }
    } else if (location.pathname.indexOf('/components') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/admin/components'
      }
    } else if (location.pathname.indexOf('/user') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/admin/user/list'
      }
    } else if (location.pathname.indexOf('/organizations') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/admin/organizations/list'
      }
    } else if (location.pathname.indexOf('/dashboard') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/dashboard'
      }
    } else if (location.pathname.indexOf('/system/models') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/system/models'
      }
    } else if (location.pathname.indexOf('/cases') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/incident/cases'
      }
    } else if (location.pathname.indexOf('/extraction') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/system/extraction'
      }
    } else if (location.pathname.indexOf('/mitre_attack') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/mitre_attack'
      }
    } else if (location.pathname.indexOf('/stream') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/stream/list'
      }
    } else if (location.pathname.indexOf('/enrichment') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/system/enrichment'
      }
    } else if (location.pathname.indexOf('/workbook') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/workbook/new'
      }
    } else if (location.pathname.indexOf('/eba') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/eba'
      }
    } else if (location.pathname.indexOf('/home') > -1) {
      if (scopeID === '') {
        route = '/' + cluster.clusterId + '/admin/components'
      } else {
        route = '/' + cluster.clusterId + scopeID + '/home' + scopeID + '/' + cluster.clusterId
      }
    } else {
      // console.log(location.pathname.indexOf('/home/'))
      let arr = location.pathname.replace('/', '').split('/')
      let finalroute = '/'
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          finalroute = finalroute + cluster.clusterId
        } else if (i === 1 && scopeID !== '') {
          finalroute = finalroute + scope.scope_id
        } else {
          finalroute = finalroute + arr[i]
        }
        if (i + 1 !== arr.length) {
          finalroute = finalroute + '/'
        }
      }
      //route = location.pathname.replace(/\/[A-za-z0-9-]+\//, '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id +'/')
      route = finalroute
      // console.log(route)
    }
    return route
  }

  changeCluster = cluster => {
    const { match, location, history } = this.props
    var route = ''
    if (cluster.scope_access.length > 0) {
      for (var j = 0; j < cluster.scope_access.length; j++) {

        if (cluster.scope_access[j].role === 'Viewer') {
          route = '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id + '/dashboard'
          break
        } else if (cluster.scope_access[j].role !== 'No Access') {
          route = '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id + '/home/' + cluster.scope_access[j].scope_id + '/' + cluster.clusterId
          // route = '/' + cluster.clusterId + '/' + cluster.scope_access[j].scope_id + '/workbook/new'
          break
        } else {
          route = this.getRouteUrl(cluster, cluster.scope_access[j], location)
        }
        this.setState({ clusterName: cluster.clusterName }, () => {
          return this.state.clusterName
        })
      }
    } else {
      if (this.state.accessData.data.isAdmin === true) {
        route = this.getRouteUrl(cluster, {}, location)
      } else {
        route = '/' + cluster.clusterId + '/no-access/auth/no-access'
      }
    }
    if (cluster !== null) {
      var userPayload = Common.decryptData(localStorage.getItem('userPayload'))
      userPayload['licenseType'] = cluster.licenseType
      var userAcc = ''
      if (cluster.scope_access.length > 0) {
        if (this.state.accessData.data.isAdmin === true) {
          if (cluster.access_type === 'Administrator') {
            userAcc = 'Admin - SecAdmin ' + cluster.scope_access[0].role
          } else {
            userAcc = 'Admin - ' + cluster.scope_access[0].role
          }
        } else {
          if (cluster.access_type === 'Administrator') {
            userAcc = 'User - SecAdmin ' + cluster.scope_access[0].role
          } else {
            userAcc = 'User - ' + cluster.scope_access[0].role
          }
        }
      } else {
        if (this.state.accessData.data.isAdmin === true) {
          userAcc = 'Admin - No Access'
        } else {
          userAcc = 'User - No Access'
        }
      }
      if (userAcc !== '') {
        userPayload.role = userAcc
        userPayload.clusterId = cluster.clusterId
        userPayload.selectedCluster = cluster
        userPayload.scope_id =
          cluster.scope_access.length > 0 ? cluster.scope_access[0].scope_id : ''
        localStorage.setItem('UserAcc', Common.encryptData(userAcc, true))
      }
      localStorage.setItem('userPayload', Common.encryptData(userPayload))
    }
    history.push(route)
    window.location.reload(false)
  }

  upDateAccSelection = dataAcc => {
    var responseData = dataAcc
    var clusterUrl = window.location.hash.replace('#/', '').split('/')[0]
    var scopeurl = window.location.hash.replace('#/', '').split('/')[1]
    var selectCls = {}
    var selectScop = {}
    for (var i = 0; i < responseData.data.access.length; i++) {
      if (responseData.data.access[i].clusterId === clusterUrl) {
        selectCls = responseData.data.access[i]
        for (var j = 0; j < responseData.data.access[i].scope_access.length; j++) {
          if (
            responseData.data.access[i].scope_access[j].scope_id === scopeurl &&
            responseData.data.access[i].scope_access[j].role !== 'No Access'
          ) {
            selectScop = responseData.data.access[i].scope_access[j]
          }
        }
      }
    }
    var dat = { cluster: selectCls, scope: selectScop }
    this.props.updateScopeData(selectScop)
    this.props.updateSelection(dat, this.props.AllAccessData)
    this.props.updateAcc(dat)
    var accessStr = ''
    var userPayload = Common.decryptData(localStorage.getItem('userPayload'))
    if (responseData.data.isAdmin && selectCls.access_type !== 'No Access') {
      if (Object.keys(selectScop).length > 0) {
        if (selectCls.access_type === 'Administrator') {
          accessStr = 'Admin - SecAdmin ' + selectScop.role
        } else {
          accessStr = 'Admin - ' + selectScop.role
        }
      } else {
        accessStr = 'Admin - No Access'
      }
    } else if (!responseData.data.isAdmin && selectCls.access_type !== 'No Access') {
      if (Object.keys(selectScop).length > 0) {
        if (selectCls.access_type === 'Administrator') {
          accessStr = 'User - SecAdmin ' + selectScop.role
        } else {
          accessStr = 'User - ' + selectScop.role
        }
      } else {
        accessStr = 'User - No Access'
      }
    }
    if (accessStr !== '') {
      userPayload.role = accessStr
      // localStorage.setItem('userPayload', Common.encryptData(userPay))
      this.props.updateUserRole(accessStr)
    }
    userPayload.licenseType = selectCls.licenseType
    userPayload.clusterId = selectCls.clusterId
    userPayload.scope_id = Object.keys(selectScop).length > 0 ? selectScop.scope_id : ''
    localStorage.setItem('userPayload', Common.encryptData(userPayload))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      var current = this.props.location.pathname.split('/')
      var next = nextProps.location.pathname.split('/')
      if (typeof this.props.AllAccessData !== 'undefined') {
        this.upDateAccSelection(this.props.AllAccessData)
      }
    }
  }

  componentDidUpdate() {
    var scopeurl = window.location.hash.replace('#/', '').split('/')[1]
    var clusterUrl = window.location.hash.replace('#/', '').split('/')[0]
    var currentCluster = this.props.location.pathname.split('/')[1]
    var currentScope = this.props.location.pathname.split('/')[2]
    if (clusterUrl !== currentCluster) {
      window.location.reload(false)
    } else {
      if (scopeurl !== currentScope && !window.location.hash.includes('auth/login')) {
        window.location.reload(false)
      }
    }
  }

  render() {
    // const accData = this.props.AllAccessData
    // const clusterName = this.props.selectedCluster
    // const SelectedScope = this.props.selectedScope
    return (
      <div>
        {typeof this.props.AllAccessData !== 'undefined' ? (
          <>
            {Object.keys(this.props.AllAccessData).length > 0 ? (
              this.props.AllAccessData.data.access.length > 1 ? (
                <Dropdown
                  trigger={['click']}
                  defaultSelectedKeys={this.props.selectedCluster.clusterId}
                  overlay={
                    <Menu
                      style={{
                        width: '150px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'left',
                      }}
                    >
                      {this.props.AllAccessData.data.access.length > 1
                        ? this.props.AllAccessData.data.access.map((item, index) => (
                          <Menu.Item
                            onClick={() => this.changeCluster(item)}
                            key={item.clusterId}
                            className={this.props.selectedCluster.clusterId === item.clusterId ? 'topbarSelect' : ''}
                            style={{ color: this.props.selectedCluster.clusterId === item.clusterId ? 'deeepskyblue' : '#d3d3d3' }}
                          >
                            {item.clusterName}
                          </Menu.Item>
                        ))
                        : null}
                    </Menu>
                  }
                >
                  <Button type="link" onClick={e => e.preventDefault()}>
                    <span style={{ marginRight: '5px' }}>
                      <i className="fal fa-network-wired" />
                    </span>
                    {this.props.selectedCluster.clusterName}
                    {this.props.AllAccessData.data.access.length > 1 ? (
                      <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                    ) : null}
                  </Button>
                </Dropdown>
              ) : (
                <Button type="link" onClick={e => e.preventDefault()}>
                  <span style={{ marginRight: '5px' }}>
                    <i className="fal fa-network-wired" />
                  </span>
                  {this.props.selectedCluster.clusterName}
                  {this.props.AllAccessData.data.access.length > 1 ? (
                    <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                  ) : null}
                </Button>
              )
            ) : null}
            {!(
              window.location.toString().includes('admin/clusters') ||
              window.location.toString().includes('admin/user') ||
              window.location.toString().includes('admin/organizations') ||
              window.location.toString().includes('admin/components') ||
              window.location.toString().includes('admin/smtp') ||
              window.location.toString().includes('admin/switchboard')
            ) &&
              (typeof this.props.selectedCluster.scope_access !== 'undefined' ? (
                this.props.selectedCluster.scope_access.length > 1 ? (
                  <>
                    {/* / */}
                    <Dropdown
                      trigger={['click']}
                      placement="bottomRight"
                      defaultSelectedKeys={this.props.selectedScope?.scope_id}
                      overlay={
                        <Menu
                          style={{
                            // borderTop: '2px solid #1890ff',
                            // borderRadius: '4px',
                            width: '150px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'left',
                          }}
                        >
                          {this.props.selectedCluster.scope_access.length > 1
                            ? this.props.selectedCluster.scope_access.map(
                              item =>
                                item.role !== 'No Access' ? (
                                  <Menu.Item
                                    key={item.scope_id}
                                    className={
                                      this.props.selectedScope?.scope_id === item.scope_id
                                        ? 'topbarSelect'
                                        : ''
                                    }
                                    onClick={() => {
                                      this.setScope(item)
                                    }}
                                  >
                                    {item.scope_name}
                                  </Menu.Item>
                                ) : null,

                              // </Link>
                            )
                            : null}
                        </Menu>
                      }
                    >
                      {this.props.selectedScope?.scope_name &&
                        this.props.selectedScope?.scope_name.length > 0 && (
                          <Button type="link" onClick={e => e.preventDefault()}>
                            <span style={{ marginRight: '5px' }}>
                              <i className="fal fa-bullseye-pointer" />
                            </span>
                            {this.props.selectedScope?.scope_name}
                            {this.props.selectedCluster.scope_access.length > 1 ? (
                              <i
                                style={{ marginLeft: '5px' }}
                                className={'fal fa-chevron-down'}
                              ></i>
                            ) : null}
                          </Button>
                        )}
                    </Dropdown>
                  </>
                ) : (
                  this.props.selectedScope?.scope_name &&
                  this.props.selectedScope?.scope_name.length > 0 && (
                    <Button
                      type="link"
                      onClick={e => e.preventDefault()}
                      style={{ cursor: 'default' }}
                    >
                      <span style={{ marginRight: '5px' }}>
                        <i className="fal fa-bullseye-pointer" />
                      </span>
                      {this.props.selectedScope?.scope_name}
                      {this.props.selectedCluster.scope_access.length > 1 ? (
                        <i style={{ marginLeft: '5px' }} className={'fal fa-chevron-down'}></i>
                      ) : null}
                    </Button>
                  )
                )
              ) : null)}
          </>
        ) : null}
      </div>
    )
  }
}

export default ClusterScopetab
